import {RouteProp} from '@react-navigation/native';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {
  AuthScreenTemplate,
  Button,
  Spacer,
  ValidationInput,
} from '../../Components';
import {formRules} from '../../Utils';
import {AuthStackNavigationParms} from './AuthenticationStack';

type Props = {
  navigation: NativeStackNavigationProp<AuthStackNavigationParms, 'ForgotPassword'>;
  route: RouteProp<AuthStackNavigationParms, 'ForgotPassword'>;
};

const ForgotPasswordScreen: React.FC<Props> = ({navigation, route}) => {
  const [loading] = useState<boolean>(false);
  const {control, handleSubmit} = useForm();
  const email = route?.params?.email;

  return (
    <AuthScreenTemplate
      title="Forgot Your Password?"
      subtitle="Reset Your password with email"
      goBack={navigation.goBack}>
      <>
        <ValidationInput
          placeholder="Email"
          disabled={loading}
          defaultValue={email && email}
          //react-hook-form
          control={control}
          name="email"
          rules={formRules.email}
        />
        <Spacer height={34} />

        <Button
          varient="fill"
          loading={loading}
          onPress={handleSubmit(data => {})}>
          Sent reset link
        </Button>
      </>
    </AuthScreenTemplate>
  );
};
export default ForgotPasswordScreen;
